/* @ngInject */
function adminService (ConnectorWebService, CONSTANTS, Utils, RequestDeduplicationService) {
  const service = {
    getUsers,
    getUsersSimplified,
    deleteUser,
    updateUser,
    updateUserPassword,
    inviteTeamMembers,
    resendInviteEmail,
    resendAllUsersPending,
    resendInvitatesByUsers,
    getArtCategoriesByProduct,
    getProducts,
    getCustomerProducts,
    addProductToCompany,
    removeProductFromCompany,
    convertArtToTemplate,
    updateTemplateSettings,
    getPostCategories,
    deletePostCategory,
    createPostCategory,
    editPostCategory,
    getActiveUsers,
    addUserToCompany,
    deleteUserFromCompany,
    getInvitationLink,
    getEnvironments,
    getUserCompanies,
    existUser,
    userHasData,
    inactivateUser,
    updateUserStatus,
    getActiveAndInactiveUserCompanies,
    getUserById,
    filterUsers,
    filterUsersCount,
    changeUsersGroups,
    inactivateSelectedUsers,
    activateSelectedUsers,
    exportUsers,
    getAllCompanies,
    userExistsInCompany,
    createCustomerCompany,
    getCompanyWithBillingPackage,
    updateCompanyBillingPackage,
    getCompanyBillingPackageAddons,
    updateTemplateInstructions,
    verifyContextFields,
    getUsersEmailsShareLinks,
    getUsersEmailsRecentsShareLinks,
    filterGuests,
    inviteGuest,
    deleteGuest,
    updateGuest,
    getSharedWithGuest,
    inactiveGuest,
    deleteSharedItensWithGuest,
    regenerateApiKey
  }
  return service

  function applyFilters (url, options) {
    const { filter, top, skip } = options

    if (filter) {
      url = Utils.fnAddQueryToUrl(url, filter)
    }

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function getUsers (top, skip, userFilters, isAnalytics) {
    let url = CONSTANTS.URL_USERS

    if (isAnalytics) {
      url = Utils.fnAddQueryToUrl(url, { isAnalytics })
    }

    if (userFilters && userFilters.ignoreUserIds && userFilters.ignoreUserIds.length) {
      url = Utils.fnAddQueryToUrl(url, { ignoreUserIds: userFilters.ignoreUserIds })
    }

    const options = { filter: userFilters, top, skip }
    return applyFilters(url, options)
  }

  function getUsersSimplified (params) {
    const url = CONSTANTS.URL_USERS_SIMPLIFIED
    return applyFilters(url, { filter: params })
  }

  function deleteUser (id) {
    return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ID, [id]))
  }

  function deleteUserFromCompany (newCustomerCompanyId, id) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANY_USERS, [id])
    url = Utils.fnAddQueryToUrl(url, { newCustomerCompanyId })
    return ConnectorWebService.fnDelete(url)
  }

  function getInvitationLink (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_GET_INVITATION, [id])

    return ConnectorWebService.get(url)
  }

  function updateUser (id, data) {
    return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ID, [id]), data)
  }

  function updateUserPassword (id, password) {
    return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ID_PASSWORD, [id]), { password })
  }

  function inviteTeamMembers (data) {
    return ConnectorWebService.post(CONSTANTS.URL_USERS_INVITE, data)
  }

  function resendInviteEmail (userId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_INVITE_ID_RESEND, [userId])
    return ConnectorWebService.get(url)
  }

  function resendAllUsersPending (customerCompanyId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANY_INVITATION_PENDING_RESEND_ALL_USERS, [
      customerCompanyId
    ])
    return ConnectorWebService.get(url)
  }

  function resendInvitatesByUsers (users) {
    let url = CONSTANTS.URL_NEW_USERS_INVITES_RESEND

    users.forEach(item => {
      url = Utils.fnAddQueryToUrl(url, { userIds: item })
    })

    return ConnectorWebService.get(url)
  }

  function getArtCategoriesByProduct (productId, top, skip) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_CATEGORIES_PRODUCT_ID, [productId])
    const options = { top, skip }
    return applyFilters(url, options)
  }

  function getProducts (top, skip) {
    const url = CONSTANTS.URL_PRODUCTS
    const options = { top, skip }
    return applyFilters(url, options)
  }

  function getCustomerProducts (top, skip) {
    const url = CONSTANTS.URL_PRODUCTS
    const options = { top, skip }
    return applyFilters(url, options)
  }

  function addProductToCompany (data) {
    return ConnectorWebService.post(CONSTANTS.URL_CUSTOMER_PRODUCTS, data)
  }

  function removeProductFromCompany (id) {
    return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_PRODUCTS_ID, [id]))
  }

  function convertArtToTemplate (artId, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_CONVERT_TEMPLATE, [artId])

    return ConnectorWebService.put(url, payload)
  }

  function updateTemplateSettings (artId, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_UPDATE_TEMPLATE_SETTINGS, [artId])

    if (window.__DeskfyObserver__) {
      window.__DeskfyObserver__[`template-${artId}`] = payload.name
    }

    return ConnectorWebService.put(url, payload)
  }

  function updateTemplateInstructions (artId, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_UPDATE_TEMPLATE_INSTRUCTIONS, [artId])

    return ConnectorWebService.put(url, payload)
  }

  function getPostCategories (top, skip) {
    const url = CONSTANTS.URL_POST_CATEGORIES_EXTENDED
    const options = { top, skip }
    return applyFilters(url, options)
  }

  function deletePostCategory (id) {
    return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_POST_CATEGORIES_BY_ID, [id]))
  }

  function createPostCategory (data) {
    return ConnectorWebService.post(CONSTANTS.URL_POST_CATEGORIES, data)
  }

  function editPostCategory (id, data) {
    return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_POST_CATEGORIES_BY_ID, [id]), data)
  }

  function getActiveUsers (customerCompanyId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANY_GET_ACTIVE_USERS, [customerCompanyId])
    return ConnectorWebService.get(url)
  }

  function addUserToCompany (email, groups, companyId = null, consultants = []) {
    return ConnectorWebService.post(CONSTANTS.URL_CUSTOMER_COMPANIES_ADD_USER, { email, groups, companyId, consultants })
  }

  function getEnvironments (userId, search) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CONTEXTS_BY_USER_ID, [userId])

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    return ConnectorWebService.get(url)
  }

  function getUserCompanies (userId, filters) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ID_COMPANIES, [userId])

    if (filters) {
      url = Utils.fnAddQueryToUrl(url, filters)
    }

    return ConnectorWebService.get(url)
  }

  function existUser (email) {
    const options = Object.assign({}, { email })
    const url = Utils.fnAddQueryToUrl(CONSTANTS.URL_USERS_EXIST_EMAIL, options)
    return ConnectorWebService.get(url)
  }

  function userHasData (id) {
    return ConnectorWebService.get(Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_HAS_DATA, [id]))
  }

  function inactivateUser (id) {
    return ConnectorWebService.post(Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_INACTIVATE, [id]))
  }

  function updateUserStatus (id, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ID_ACTIVE, [id])
    return ConnectorWebService.put(url, payload)
  }

  function getActiveAndInactiveUserCompanies (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ID_COMPANIES_ALL, [id])
    return ConnectorWebService.get(url)
  }

  function getUserById (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ID, [id])
    return ConnectorWebService.get(url)
  }

  function getUsersEmailsRecentsShareLinks (top, skip) {
    let url = CONSTANTS.URL_RECENTS_EMAILS_SHARE_LINKS

    if (top && skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function getUsersEmailsShareLinks (top, skip, params, sort) {
    let url = CONSTANTS.URL_EMAILS_SHARE_LINKS

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (sort?.$sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.$sort })
    }

    if (sort?.$order) {
      url = Utils.fnAddQueryToUrl(url, { $order: sort.$order })
    }

    if (params?.search) {
      url = Utils.fnAddQueryToUrl(url, { search: params.search })
    }

    url = _handleInternalUsers(url, params)

    return ConnectorWebService.get(url)
  }

  function filterUsers (top, skip, params, sort) {
    let url = CONSTANTS.URL_NEW_USERS

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (sort?.$sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.$sort })
    }

    if (sort?.$order) {
      url = Utils.fnAddQueryToUrl(url, { $order: sort.$order })
    }

    if (params?.search) {
      url = Utils.fnAddQueryToUrl(url, { search: params.search })
    }

    if (params?.groups) {
      params.groups.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { groups: item })
      })
    }

    if (params?.status) {
      params.status.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { status: item })
      })
    }

    if (params?.permissions) {
      params.permissions.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { permissions: item })
      })
    }

    if (params && params.users) {
      params.users.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { userIds: item })
      })
    }

    url = _handleInternalUsers(url, params)

    return ConnectorWebService.get(url)
  }

  function _handleInternalUsers (url, { internalSearch }) {
    const defaultURL = url

    if (internalSearch === true) {
      // will return ONLY internal users
      return Utils.fnAddQueryToUrl(url, { internalSearch: true })
    }

    if (internalSearch === false) {
      // hide internal users, if set to false, will return ALL users
      return Utils.fnAddQueryToUrl(url, { hideInternalUsers: true })
    }

    if (internalSearch === null) {
      // show all users
      return Utils.fnAddQueryToUrl(url, { internalSearch: false })
    }

    return defaultURL
  }

  function filterUsersCount (params) {
    let url = CONSTANTS.URL_NEW_USERS_COUNT_STATUS

    if (params?.search) {
      url = Utils.fnAddQueryToUrl(url, { search: params.search })
    }

    if (params?.groups) {
      params.groups.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { groups: item })
      })
    }

    if (params?.selectedStatusCache) {
      params.selectedStatusCache.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { status: item })
      })
    }

    if (params?.permissions) {
      params.permissions.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { permissions: item })
      })
    }

    if (params && params.users) {
      params.users.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { userIds: item })
      })
    }

    if (params?.hideInternalUsers) {
      url = Utils.fnAddQueryToUrl(url, { hideInternalUsers: params.hideInternalUsers })
    }

    return ConnectorWebService.get(url)
  }

  function changeUsersGroups (usersWithGroups) {
    const url = CONSTANTS.URL_NEW_USERS_GROUPS

    return ConnectorWebService.put(url, { usersWithGroups })
  }

  function inactivateSelectedUsers (userIds) {
    let url = CONSTANTS.URL_NEW_USERS_INACTIVATE

    userIds.forEach(item => {
      url = Utils.fnAddQueryToUrl(url, { userIds: item })
    })

    return ConnectorWebService.put(url)
  }

  function activateSelectedUsers (users) {
    const url = CONSTANTS.URL_NEW_USERS_ACTIVATE

    return ConnectorWebService.put(url, { users })
  }

  function exportUsers (params, sort) {
    let url = CONSTANTS.URL_NEW_USERS_EXPORT

    if (sort?.$sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.$sort })
    }

    if (sort?.$order) {
      url = Utils.fnAddQueryToUrl(url, { $order: sort.$order })
    }

    if (params?.search) {
      url = Utils.fnAddQueryToUrl(url, { search: params.search })
    }

    if (params?.businessUnits) {
      url = Utils.fnAddQueryToUrl(url, { showUnits: params.businessUnits })
    }

    if (params?.groups) {
      params.groups.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { groups: item })
      })
    }

    if (params?.permissions) {
      params.permissions.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { permissions: item })
      })
    }

    if (params?.status) {
      params.status.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { status: item })
      })
    }

    if (params && params.users) {
      params.users.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { userIds: item })
      })
    }

    return ConnectorWebService.get(url)
  }

  function getAllCompanies (params = {}) {
    const { $top, $skip, filters = {} } = params
    let url = CONSTANTS.URL_CUSTOMER_COMPANIES

    if ($top) {
      url = Utils.fnAddQueryToUrl(url, { $top })
    }

    if ($skip) {
      url = Utils.fnAddQueryToUrl(url, { $skip })
    }

    if (filters.search) {
      url = Utils.fnAddQueryToUrl(url, { search: filters.search })
    }

    if (filters.status) {
      const status = Array.isArray(filters.status) ? filters.status : [filters.status]

      url = Utils.addQueryStringFromArray(url, 'status', status)
    }

    return ConnectorWebService.get(url)
  }

  function userExistsInCompany (params = {}) {
    const { companyId, userId } = params
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANY_ID_USER_ID_EXISTS, [companyId, userId])

    return ConnectorWebService.get(url)
  }

  function createCustomerCompany (data) {
    const url = CONSTANTS.URL_CUSTOMER_COMPANIES

    return ConnectorWebService.post(url, data)
  }

  function getCompanyWithBillingPackage (companyId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_V2_CUSTOMER_COMPANIES_ID, [companyId])
    const getCompanyWithBillingPackageRequest = () => ConnectorWebService.get(url)
    return RequestDeduplicationService.deduplicateRequest('AdminServiceGetCompanyWithBillingPackage', getCompanyWithBillingPackageRequest)
  }

  function updateCompanyBillingPackage (companyId, planId, data = {}) {
    const { maxLicenses, maxStorageGb, addonsIds } = data
    const payload = {
      planId
    }

    if (maxLicenses) {
      payload.maxLicenses = maxLicenses
    }

    if (maxStorageGb) {
      payload.maxStorageGb = maxStorageGb
    }

    if (Array.isArray(addonsIds)) {
      payload.addonsIds = addonsIds
    }

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANIES_ID_BILLING_PACKAGE, [companyId])
    return ConnectorWebService.put(url, payload)
  }

  function getCompanyBillingPackageAddons (billingPackageId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_V2_BILLING_PACKAGE_ID_ADDONS, [billingPackageId])
    const getCompanyBillingPackageAddonsRequest = () => ConnectorWebService.get(url)
    return RequestDeduplicationService.deduplicateRequest('AdminServiceGetCompanyBillingPackageAddons', getCompanyBillingPackageAddonsRequest)
  }

  function verifyContextFields (contextId, fields) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CONTEXTS_BY_ID_VERIFY_FIELDS, [contextId])
    url = Utils.addQueryStringFromArray(url, 'fields', fields)

    return ConnectorWebService.get(url)
  }

  function filterGuests (top, skip, params, sort) {
    let url = CONSTANTS.URL_GUESTS

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (sort?.$sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.$sort })
    }

    if (sort?.$order) {
      url = Utils.fnAddQueryToUrl(url, { $order: sort.$order })
    }

    if (params?.search) {
      url = Utils.fnAddQueryToUrl(url, { search: params.search })
    }

    if (params?.status) {
      params.status.forEach(item => {
        url = Utils.fnAddQueryToUrl(url, { status: item })
      })
    }

    return ConnectorWebService.get(url)
  }

  function inviteGuest (data) {
    return ConnectorWebService.post(CONSTANTS.URL_GUESTS, data)
  }

  function deleteGuest (id) {
    return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_NEW_USERS_DELETE, [id]))
  }

  function updateGuest (id, data) {
    return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_GUESTS_ID, [id]), data)
  }

  function getSharedWithGuest (id, top, skip, sort) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARED_WITH_GUEST, [id])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (sort?.$sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.$sort })
    }

    if (sort?.$order) {
      url = Utils.fnAddQueryToUrl(url, { $order: sort.$order })
    }

    return ConnectorWebService.get(url)
  }

  function inactiveGuest (id, data) {
    return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ID_ACTIVE, [id]), data)
  }

  function deleteSharedItensWithGuest (id, items) {
    return ConnectorWebService.post(Utils.fnReplaceStringParams(CONSTANTS.URL_DELETE_SHARED_WITH_GUEST, [id]), { items })
  }

  function regenerateApiKey () {
    const url = CONSTANTS.URL_CUSTOMER_COMPANY_APIKEY

    return ConnectorWebService.post(url)
  }
}

export { adminService }
